import type { Vector3 } from "three";

/**
 * Compare two Vector3 objects by their x, y, z values.
 * Returns true if they are equal (should NOT re-render).
 */
export const areVector3Equal = (
  a: Vector3 | undefined,
  b: Vector3 | undefined
): boolean => {
  if (a === b) return true;
  if (!a || !b) return false;
  return a.x === b.x && a.y === b.y && a.z === b.z;
};
